import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";

const useColorSchemeIsLight = () => {
  const { state } = useManageMyGivingPage();
  return state?.pageSettings?.colorSchemeIsLight;
};

export default useColorSchemeIsLight;
